import { SearchFacetFilters as BaseComponent } from "lemans-brandsites-common/components/SearchFacetFilters/SearchFacetFilters.component";
import * as React from 'react';
import './SearchFacetFilters.styles.less';
import { ISearchFacetFiltersProps } from "./SearchFacetFilters.types";

export const SearchFacetFilters = (props:ISearchFacetFiltersProps) => <BaseComponent {...props} />;
